import { render, staticRenderFns } from "./PurchasingList.vue?vue&type=template&id=3f7a36f2&"
import script from "./PurchasingList.vue?vue&type=script&lang=js&"
export * from "./PurchasingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports